// extracted by mini-css-extract-plugin
export default {"root":"CreateAlbum__root--1jU7c","addIcon":"CreateAlbum__addIcon--OONXt","add":"CreateAlbum__add--1S1xO"};